import { render, staticRenderFns } from "./ArticleReward.vue?vue&type=template&id=06f646ee&scoped=true&"
import script from "./ArticleReward.vue?vue&type=script&lang=js&"
export * from "./ArticleReward.vue?vue&type=script&lang=js&"
import style0 from "./ArticleReward.vue?vue&type=style&index=0&id=06f646ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f646ee",
  null
  
)

export default component.exports